// src/pages/Copyright.jsx

import React, { useEffect } from 'react';
import { Copyright as CopyrightIcon, Shield, FileText, AlertCircle, Mail } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import Footer from '../components/Footer';
import Header from '../components/Header';

const Copyright = () => {
  const { language } = useLanguage();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const content = {
    en: {
      title: "Copyright Notice",
      subtitle: "Protecting our intellectual property and content",
      lastUpdated: "Last Updated: December 13, 2024",
      sections: [
        {
          icon: CopyrightIcon,
          title: "1. Copyright Ownership",
          content: [
            "All content on this website, including text, graphics, logos, images, and software, is the property of Shree Enterprises E-Seva Kendra and is protected by Indian and international copyright laws.",
            "© 2024 Shree Enterprises E-Seva Kendra. All rights reserved.",
            "Unauthorized reproduction, distribution, or use of any content from this website is strictly prohibited."
          ]
        },
        {
          icon: Shield,
          title: "2. Permitted Use",
          content: [
            "You may view, download, and print content from this website for personal, non-commercial use only.",
            "You may share links to our website on social media and other platforms.",
            "Any commercial use of our content requires prior written permission from Shree Enterprises E-Seva Kendra."
          ]
        },
        {
          icon: AlertCircle,
          title: "3. Restrictions",
          content: [
            "You may not modify, reproduce, republish, upload, post, transmit, or distribute any content from this website without authorization.",
            "You may not use our logo, brand name, or trademarks without explicit written consent.",
            "You may not frame or use framing techniques to enclose any content from our website.",
            "Violation of these restrictions may result in legal action and liability for damages."
          ]
        },
        {
          icon: FileText,
          title: "4. Third-Party Content",
          content: [
            "Some content on our website may be owned by third parties, including government agencies and service providers.",
            "Such content is used with permission or under applicable laws and regulations.",
            "Trademarks and logos of third parties remain the property of their respective owners."
          ]
        },
        {
          icon: Mail,
          title: "5. Request Permissions",
          content: [
            "For permission to use our content for commercial purposes, media inquiries, or partnership opportunities, please contact us:",
            "Email: admin@shreeservz.com",
            "Phone: +91 88504 15838",
            "Address: Thane, Maharashtra, India"
          ]
        }
      ]
    },
    mr: {
      title: "कॉपीराइट सूचना",
      subtitle: "आमची बौद्धिक संपदा आणि सामग्रीचे संरक्षण",
      lastUpdated: "शेवटचे अपडेट: डिसेंबर 13, 2024",
      sections: [
        {
          icon: CopyrightIcon,
          title: "1. कॉपीराइट मालकी",
          content: [
            "या वेबसाइटवरील सर्व सामग्री, ज्यात मजकूर, ग्राफिक्स, लोगो, प्रतिमा आणि सॉफ्टवेअर समाविष्ट आहे, ती श्री एंटरप्रायजेस ई-सेवा केंद्राची मालमत्ता आहे आणि भारतीय आणि आंतरराष्ट्रीय कॉपीराइट कायद्यांद्वारे संरक्षित आहे.",
            "© 2024 श्री एंटरप्रायजेस ई-सेवा केंद्र. सर्व हक्क राखीव.",
            "या वेबसाइटवरील कोणत्याही सामग्रीचे अनधिकृत पुनरुत्पादन, वितरण किंवा वापर कठोरपणे प्रतिबंधित आहे."
          ]
        },
        {
          icon: Shield,
          title: "2. परवानगी असलेला वापर",
          content: [
            "तुम्ही या वेबसाइटवरून केवळ वैयक्तिक, गैर-व्यावसायिक वापरासाठी सामग्री पाहू, डाउनलोड आणि प्रिंट करू शकता.",
            "तुम्ही सोशल मीडिया आणि इतर प्लॅटफॉर्मवर आमच्या वेबसाइटचे दुवे शेअर करू शकता.",
            "आमच्या सामग्रीचा कोणताही व्यावसायिक वापर करण्यासाठी श्री एंटरप्रायजेस ई-सेवा केंद्राकडून पूर्व लेखी परवानगी आवश्यक आहे."
          ]
        },
        {
          icon: AlertCircle,
          title: "3. निर्बंध",
          content: [
            "अधिकृतता शिवाय तुम्ही या वेबसाइटवरील कोणतीही सामग्री सुधारू, पुनरुत्पादित करू, पुन्हा प्रकाशित करू, अपलोड करू, पोस्ट करू, प्रसारित करू किंवा वितरित करू शकत नाही.",
            "स्पष्ट लेखी संमतीशिवाय तुम्ही आमचा लोगो, ब्रँड नाव किंवा ट्रेडमार्क वापरू शकत नाही.",
            "तुम्ही आमच्या वेबसाइटवरील कोणतीही सामग्री बंद करण्यासाठी फ्रेम किंवा फ्रेमिंग तंत्र वापरू शकत नाही.",
            "या निर्बंधांचे उल्लंघन केल्यास कायदेशीर कारवाई आणि नुकसानीसाठी दायित्व येऊ शकते."
          ]
        },
        {
          icon: FileText,
          title: "4. तृतीय-पक्ष सामग्री",
          content: [
            "आमच्या वेबसाइटवरील काही सामग्री तृतीय पक्षांची असू शकते, ज्यात सरकारी एजन्सी आणि सेवा प्रदाते समाविष्ट आहेत.",
            "अशी सामग्री परवानगीसह किंवा लागू कायदे आणि नियमांनुसार वापरली जाते.",
            "तृतीय पक्षांचे ट्रेडमार्क आणि लोगो त्यांच्या संबंधित मालकांची मालमत्ता राहतात."
          ]
        },
        {
          icon: Mail,
          title: "5. परवानग्या विनंती",
          content: [
            "व्यावसायिक हेतूंसाठी आमची सामग्री वापरण्याची परवानगी, मीडिया चौकशी किंवा भागीदारी संधींसाठी, कृपया आमच्याशी संपर्क साधा:",
            "ईमेल: admin@shreeservz.com",
            "फोन: +91 88504 15838",
            "पत्ता: ठाणे, महाराष्ट्र, भारत"
          ]
        }
      ]
    }
  };

  const t = content[language];

  return (
    <>
      <style>{`
        .copyright-page {
          min-height: 100vh;
        }
           @keyframes gradientShift {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }

        .copyright-hero {
          background: linear-gradient(-45deg, #c94b4b, #4b134f, #1e3a8a, #065f46);
          background-size: 400% 400%;
          animation: gradientShift 15s ease infinite;
          color: white;
          padding: 80px 20px 60px;
          text-align: center;
          position: relative;
          overflow: hidden;
        }

        .copyright-hero::before {
          content: '';
          position: absolute;
          top: -50%;
          right: -10%;
          width: 500px;
          height: 500px;
          background: rgba(255, 255, 255, 0.1);
          border-radius: 50%;
        }

        .copyright-hero::after {
          content: '';
          position: absolute;
          bottom: -30%;
          left: -5%;
          width: 400px;
          height: 400px;
          background: rgba(255, 255, 255, 0.08);
          border-radius: 50%;
        }

        .copyright-hero-content {
          max-width: 1200px;
          margin: 0 auto;
          position: relative;
          z-index: 1;
        }

        .copyright-hero h1 {
          font-size: 48px;
          font-weight: 700;
          margin-bottom: 16px;
        }

        .copyright-hero p {
          font-size: 18px;
          opacity: 0.95;
          margin-bottom: 12px;
        }

        .last-updated {
          font-size: 14px;
          opacity: 0.9;
          font-weight: 500;
        }

        .copyright-container {
          max-width: 1000px;
          margin: 0 auto;
          padding: 60px 20px;
        }

        .copyright-section {
          background: white;
          border-radius: 16px;
          padding: 40px;
          margin-bottom: 24px;
          box-shadow: 0 4px 20px rgba(0,0,0,0.08);
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }

        .copyright-section:hover {
          transform: translateY(-4px);
          box-shadow: 0 8px 30px rgba(0,0,0,0.12);
        }

        .section-header {
          display: flex;
          align-items: center;
          gap: 16px;
          margin-bottom: 24px;
        }

        .section-icon {
          width: 48px;
          height: 48px;
          background: linear-gradient(135deg, #ff6b35 0%, #ff8c42 100%);
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          flex-shrink: 0;
        }

        .section-header h2 {
          font-size: 24px;
          color: #1a1a1a;
          font-weight: 700;
          margin: 0;
        }

        .section-content p {
          font-size: 16px;
          line-height: 1.8;
          color: #4a5568;
          margin-bottom: 16px;
        }

        .section-content p:last-child {
          margin-bottom: 0;
        }

        .important-note {
          background: #fff5f2;
          border-left: 4px solid #ff6b35;
          padding: 20px;
          border-radius: 8px;
          margin-top: 40px;
        }

        .important-note h3 {
          font-size: 18px;
          color: #ff6b35;
          margin-bottom: 12px;
          font-weight: 700;
        }

        .important-note p {
          font-size: 16px;
          color: #4a5568;
          line-height: 1.6;
          margin: 0;
        }

        @media (max-width: 768px) {
          .copyright-hero {
            padding: 60px 20px 40px;
          }

          .copyright-hero h1 {
            font-size: 32px;
          }

          .copyright-hero p {
            font-size: 16px;
          }

          .copyright-container {
            padding: 40px 20px;
          }

          .copyright-section {
            padding: 24px;
          }

          .section-header {
            flex-direction: column;
            align-items: flex-start;
            gap: 12px;
          }

          .section-header h2 {
            font-size: 20px;
          }

          .section-content p {
            font-size: 15px;
          }
        }
      `}</style>
        <Header language={language}/>
      <div className="copyright-page">
        {/* Hero Section */}
        <div className="copyright-hero">
          <div className="copyright-hero-content">
            <h1>{t.title}</h1>
            <p>{t.subtitle}</p>
            <div className="last-updated">{t.lastUpdated}</div>
          </div>
        </div>

        {/* Copyright Content */}
        <div className="copyright-container">
          {t.sections.map((section, index) => {
            const IconComponent = section.icon;
            return (
              <div key={index} className="copyright-section">
                <div className="section-header">
                  <div className="section-icon">
                    <IconComponent size={24} />
                  </div>
                  <h2>{section.title}</h2>
                </div>
                <div className="section-content">
                  {section.content.map((paragraph, pIndex) => (
                    <p key={pIndex}>{paragraph}</p>
                  ))}
                </div>
              </div>
            );
          })}

          {/* Important Note */}
          <div className="important-note">
            <h3>
              {language === 'mr' ? '© कॉपीराइट संरक्षण' : '© Copyright Protection'}
            </h3>
            <p>
              {language === 'mr'
                ? 'या वेबसाइटवरील सर्व सामग्री कॉपीराइट कायद्यांद्वारे संरक्षित आहे. अनधिकृत वापरामुळे कायदेशीर कारवाई होऊ शकते.'
                : 'All content on this website is protected by copyright laws. Unauthorized use may result in legal action.'}
            </p>
          </div>
        </div>
      </div>
      <Footer language={language}/>
    </>
  );
};

export default Copyright;